
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '625px'
    },
    closeshow: {
      type: Boolean,
      default: true
    },
    classname: {
      type: String,
      default: ''
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalshow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogTableVisible: false
    }
  },
  watch: {
    dialogTableVisible(val) {
      if (!this.dialogTableVisible) {
        // document.getElementsByTagName('html')[0].style.overflow = 'auto'
        this.$emit('close') // 关闭
      }
      // else {
      //   document.getElementsByTagName('html')[0].style.overflow = 'hidden'
      // }
      this.$emit('openlog', val) // 打开
    }
  },
  methods: {
    open() {
      this.dialogTableVisible = true
    },
    close() {
      this.dialogTableVisible = false
    }
  }
}
